<template>
  <v-form ref="form">
    <v-card class="mx-auto" max-width="640">
      <v-card-text>
        <div>Dashboarder Statistics</div>
        <p class="display-1 text--primary">Excel Export</p>
        <div class="text--primary">
          <date-picker required icon="mdi-calendar" label="Start Date" v-model="startDate" writable></date-picker>
          <date-picker required icon="mdi-calendar" label="End Date" v-model="endDate" writable></date-picker>
          <v-select
            v-model="dashboarder"
            :items="dashboardersList"
            item-text="email"
            item-value="id"
            label="Dashboarder"
            prepend-icon="mdi-account"
          ></v-select>
             <v-text-field
                prepend-icon="mdi-calculator"
                v-model="campaignSearch"
                type="text"
                name="campaign"
                label="Campaign"
              ></v-text-field>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="green darken-1" :loading="isLoading" text @click="downloadFile">
          <v-icon>mdi-download</v-icon>Download
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import DatePicker from "../components/DatePicker.vue";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
const APIUrl = process.env.VUE_APP_API_URL;

export default {
  data() {
    return {
      startDate: "",
      endDate: "",
      dashboarder: "",
      isLoading: false,
      campaignSearch:""
    };
  },
  components: {
    DatePicker
  },
  computed: {
    ...mapGetters([
      "campaign",
      "userToken",
      "dashboardersList",
      "isAdmin",
      "campaignsList",
      "selectedDashboard",
      "userRoles"
    ])
  },
  methods: {
    ...mapActions(["snackAlert", "getDashboardData", "exportData"]),
    downloadFile() {
      if (this.$refs.form.validate()) {
        if (this.dashboarder === "All Dashboarders") {
          this.dashboarder = "";
        }

        const data = {
          userToken: this.userToken,
          dateStart: moment(this.startDate).format("YYYY-MM-DD"),
          dateEnd: moment(this.endDate).format("YYYY-MM-DD"),
          dashboarderId: this.dashboarder,
          dashboard: this.selectedDashboard,
          campaign: this.campaignSearch
        };
        this.isLoading = true;
        this.exportData(data).then(response => {
          if (response.data) {
            this.isLoading = false;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "file.xls");
            document.body.appendChild(link);
            link.click();
          } else {
            this.snackAlert({
              message: "excel file wasn't sent ¯\\_(ツ)_/¯"
            });
          }
        }).catch(e=>{
          this.isLoading = false
          this.snackAlert({
              message: "excel file wasn't sent ¯\\_(ツ)_/¯"
            });
        })
      } else {
        this.snackAlert({
          message: "Please fill the required inputs ¯\\_(ツ)_/¯"
        });
      }
    }
  },
  mounted() {
    this.isLoading = true;
    if ("name" in this.selectedDashboard === false) {
      const dashboard = JSON.parse(localStorage.selectedDashboard);
      this.$store.commit("setDashboard", dashboard);
    }
    this.$store.commit("setUserRoles", JSON.parse(localStorage.userRoles));

    const payload = {
      userToken: this.userToken,
      dashboard: this.selectedDashboard
    };
    this.getDashboardData(payload); //get a list of all dashboarders for drop down
    this.isLoading = false;
  }
};
</script>